import {addEquivalency, clearEquivalencies} from '../equivalencies';
import {addRequirement, clearRequirements} from '../requirements';

import EquivalencyTypes from '../equivalencies/EquivalencyTypes';
import RequirementTypes from '../requirements/RequirementTypes';

// Actions
const UPDATE_INPUT = 'ghg/calculator/UPDATE_INPUT';
const UPDATE_ERROR = 'ghg/calculator/UPDATE_ERROR';
const DISABLE_CALCULATE_BUTTON = 'ghg/calculator/DISABLE_CALCULATE_BUTTON';
const SUBMIT_CALCULATE_FORM = 'ghg/calculator/SUBMIT_CALCULATE_FORM';
const CALCULATE = 'ghg/calculator/CALCULATE';
const INVALIDATE_CALCULATIONS = 'ghg/calculator/INVALIDATE_CALCULATIONS';

// Reducer
const initialState = {
    inputValue: '',
    error: false, // Only one field, make this an object when there are more
    errorMessage: '',
    submitCalculations: false,
    showCalculations: false,
    disableCalculateButton: true,
};

export default function reducer (state = initialState, action) {
    switch (action.type) {
        case UPDATE_INPUT:
            return {
                ...state,
                inputValue: action.inputValue.replace(/,/g, ''),
            };

        case UPDATE_ERROR:
            return {
                ...state,
                error: action.error,
                errorMessage: action.errorMessage,
            };

        case DISABLE_CALCULATE_BUTTON:
            return {
                ...state,
                disableCalculateButton: action.disableCalculateButton
            };

        case SUBMIT_CALCULATE_FORM:
            return {
                ...state,
                submitCalculations: true,
                showCalculations: true,
            };

        case CALCULATE:
            return {
                ...state,
            };

        case INVALIDATE_CALCULATIONS:
            return {
                ...state,
                showCalculations: ! ! state.submitCalculations,
            };

        default:
            return state;
    }
}

// Selectors
export const getInputValue = (state) => state.calculator.inputValue;
export const getShowCalculations = (state) => state.calculator.showCalculations;
export const getDisableCalculateButton = (state) => state.calculator.disableCalculateButton;
export const getError = (state) => state.calculator.error;
export const getErrorMessage = (state) => state.calculator.errorMessage;

// Action Creators
function disableCalculateButton(shouldDisable) {
    return {
        type: DISABLE_CALCULATE_BUTTON,
        disableCalculateButton: shouldDisable,
    }
}

function addError (errorMessage) {
    return {
        type: UPDATE_ERROR,
        error: true,
        errorMessage,
    }
}

function clearError () {
    return {
        type: UPDATE_ERROR,
        error: false,
        errorMessage: '',
    }
}

export function updateInput (inputValue) {
    return function (dispatch) {

        if (parseInt(inputValue, 10) < 0) {
            dispatch(addError('Please enter a positive number'));
            dispatch(disableCalculateButton(true));
        } else if(inputValue.match(/[a-z]/i)) {
            dispatch(addError('Please enter numbers only'));
            dispatch(disableCalculateButton(true));
        } else if (inputValue === '') {
            dispatch(clearError());
            dispatch(disableCalculateButton(true));
        } else {
            dispatch(clearError());
            dispatch(disableCalculateButton(false));
        }

        return dispatch({
            type: UPDATE_INPUT,
            inputValue,
        });
    };
}

export function calculateEquivalency () {
    return function (dispatch, getState) {
        const {calculator} = getState();

        dispatch(addEquivalency(EquivalencyTypes.HOME, calculator.inputValue));
        dispatch(addEquivalency(EquivalencyTypes.AUTOMOTIVE, calculator.inputValue));

        dispatch(addRequirement(RequirementTypes.WIND, calculator.inputValue));
        //dispatch(addRequirement(RequirementTypes.COAL, calculator.inputValue));
        dispatch(addRequirement(RequirementTypes.SOLAR, calculator.inputValue));

        return dispatch({
            type: CALCULATE,
        });
    }
}

export function submitCalculateForm () {
    return function (dispatch, getState) {
        const {calculator} = getState();

        if (calculator.disableCalculateButton) return;

        dispatch(calculateEquivalency());

        return dispatch({
            type: SUBMIT_CALCULATE_FORM,
        });
    }
}

export function invalidateCalculations () {
    return function (dispatch) {
        dispatch(clearEquivalencies());
        dispatch(clearRequirements());

        return dispatch({
            type: INVALIDATE_CALCULATIONS,
        });
    }
}


/** WEBPACK FOOTER **
 ** ./src/redux/modules/calculator/calculator.js
 **/